import * as React from "react";
import { GameStateWrapper } from "../GameStateWrapper";
import { IconsWrapper } from "../IconsWrapper";
import { LiveDetails } from "../LiveDetails";
import { PreliveDetails } from "../PreliveDetails";
import { TeamsWrapper } from "../TeamsWrapper";
export const EventCardDetails = (props) => {
    const noLeague = props.details.showLeagueInEventCard
        ? ""
        : `rj-ev-list__${props.componentPrefix}__section-item--no-league`;
    const inKickOff = props.details.event.isInKickOffState
        ? `rj-ev-list__${props.componentPrefix}__section-item--in-kick-off`
        : "";
    const classNames = `rj-ev-list__${props.componentPrefix}__section rj-ev-list__${props.componentPrefix}__event-info ${noLeague} ${inKickOff}`;
    return (React.createElement("a", { href: props.details.event.linkUrl, onClick: props.details.handlers.eventCard, className: `${classNames} `, "data-uat": `a-ev-list-${props.componentPrefix}-event-info` },
        React.createElement(GameStateWrapper, { details: props.details, componentPrefix: props.componentPrefix }),
        React.createElement(TeamsWrapper, { details: props.details, componentPrefix: props.componentPrefix }),
        props.details.event.isLive
            ? React.createElement(LiveDetails, { event: props.details.event, dict: props.details.dict, componentPrefix: props.componentPrefix })
            : React.createElement(PreliveDetails, { event: props.details.event, componentPrefix: props.componentPrefix }),
        React.createElement(IconsWrapper, { details: props.details, componentPrefix: props.componentPrefix })));
};
//# sourceMappingURL=EventCardDetails.js.map